import PropTypes from 'prop-types';
import React from 'react';

// aria-label is the caller's own title, which is the accessibility contract callers' specs
// select on. aria-controls is passed ONLY when the caller actually renders an expanded
// region — a dangling reference is worse than none.
const ToggleSwitch = ({ on, disabled, onChange, label, controls, testId }) => (
  <button
    type="button"
    role="switch"
    aria-checked={on}
    aria-label={label}
    aria-controls={controls}
    disabled={disabled}
    data-testid={testId}
    className={`od-toggle${on ? ' od-toggle--on' : ''}`}
    onClick={() => onChange(!on)}
  >
    <span className="od-toggle__knob" />
  </button>
);

ToggleSwitch.propTypes = {
  on: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  controls: PropTypes.string,
  testId: PropTypes.string.isRequired,
};

ToggleSwitch.defaultProps = { on: false, disabled: false, controls: undefined };

export default ToggleSwitch;
